import { render, staticRenderFns } from "./TestChatWidget.vue?vue&type=template&id=ad5db636"
import script from "./TestChatWidget.vue?vue&type=script&lang=js"
export * from "./TestChatWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports